import { jsx as _jsx } from "react/jsx-runtime";
import { StyledIcon, StyledSvg } from './Icon.style';
export function Icon({ name, size = 'Small', title, angle, color, highlightColor, onClick, }) {
    return (_jsx(StyledIcon, { title: title, size: size, onClick: onClick, children: _jsx(StyledSvg, { className: `icon-${name}`, angle: angle, size: size, color: color, highlightColor: highlightColor, style: angle ? { transform: `rotate(${angle}deg)` } : {}, children: _jsx("use", { xlinkHref: `#${name}` }) }) }));
}
//# sourceMappingURL=Icon.js.map